export default Object.freeze({
  //파트너 조회
  LIST_TITLE: '파트너 조회',
  WAITING: '등록대기',
  INVESTIGATION: '검토중',
  ACTIVE: '등록완료',
  TRUE: '있음',
  FALSE: '없음',
  PARTNERNO: '파트너번호',
  PARTNERNAME: '파트너명',
  COUNTRY: '국적',
  COMPANYNAME: '회사명',
  PARTNERSTATUS: 'shop by등록여부',
  PRODUCTREGISTERED: '상품등록',
  REGISTRATIONNO: '사업자번호',
  OMDNO: '통신판매신고번호',
  CREATEDDATETIME: '등록일시',
	CREATED_DATE_TIME: '등록일시',
	CONTRACTED_DATE_TIME: '거래일시',
	SEARCH_DATE_TIME: '기간검색',
	MALL_NAME: '쇼핑몰명',
  CHOOSE: '선택',
  SEARCHTYPE_TTL: '검색어',
  SHOPPINGMALL: '거래쇼핑몰',
  PARTNER_STATUS: '파트너 상태',
  CONTRACT_STATUS: '거래 상태',
  CONTRACT_STATUS_WAITING: '거래대기',
  CONTRACT_STATUS_INVESTIGATION: '검토중',
  CONTRACT_STATUS_ACTIVE: '거래중',
  CONTRACT_STATUS_SUSPEND: '거래 일시중단',
  ADMINNO: '담당 MD 운영자명',
  NOSTATUS: '상태없음',
  PLEASE_INPUT: '검색어를 입력하세요',
  PLACEHOLDER: '검색어 입력',
  PARTNER_CHANGE: '담당자 변경',
	
	CONTRACT: '거래일시',
	CREATED: '등록일시',
  COMMISSION_RATE: '수수료율',
  NOT_USED: '사용 안 함',
})
